import React, { useEffect, useState, useRef } from "react";
import { format, isValid } from "date-fns";
import { fetchCurrentDateTime } from "../../login/services/LoginServices.js";
import { useDispatch } from "react-redux";
import { updateDateTime } from "../../authentication/slices/dateTimeSlice";

export function LatestDateTime() {
  const [displayDate, setDisplayDate] = useState("");
  const [time, setTime] = useState("");
  const dispatch = useDispatch();
  const timeStampRef = useRef(null); // persist timestamp across renders

  const updateDateTimeState = (res) => {
    const dateObj = new Date(res);
    if (!isValid(dateObj)) return;

    const currentDate = dateObj.valueOf();
    const currentTime = format(dateObj, "hh:mm a");
    const formattedDate = format(dateObj, "dd-MM-yyyy");

    localStorage.setItem("dateTime", Number(currentDate));
    localStorage.setItem("dateTimeString", dateObj.toString());

    setDisplayDate(formattedDate);
    setTime(currentTime);
    dispatch(updateDateTime({ currentDate, currentTime }));

    timeStampRef.current = dateObj;
  };

  const fetchAndUpdate = async () => {
    try {
      const response = await fetchCurrentDateTime();
      updateDateTimeState(response.data);
    } catch (err) {
      console.error("Error fetching current date/time:", err);
    }
  };

  useEffect(() => {
    // Fetch immediately when component mounts
    fetchAndUpdate();

    // Keep updating every 1 minute even if app is idle
    const interval = setInterval(fetchAndUpdate, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-center p-2 text-xs hidden lg:grid">
      <span>{displayDate}</span>
      <span>{time}</span>
    </div>
  );
}

// import { format, isValid } from "date-fns";
// import React from "react";
// import { fetchCurrentDateTime } from "../../login/services/LoginServices.js";
// import { useDispatch } from "react-redux";
// import { updateDateTime } from "../../authentication/slices/dateTimeSlice";

// export function LatestDateTime() {
//   const [displayDate, setDisplayDate] = React.useState("");
//   const [time, setTime] = React.useState("");
//   const dispatch = useDispatch();
//   let timeStamp;

//   React.useEffect(() => {
//     fetchCurrentDateTime()
//       .then((response) => response.data)
//       .then((res) => {
//         const currentDate = new Date(res).valueOf();
//         localStorage.setItem("dateTime", Number(currentDate));
//         localStorage.setItem("dateTimeString", new Date(res));
//         let today = timeStamp;
//         let valid = isValid(today);
//         const currentTime = valid && !!today && format(today, "hh:mm a");
//         const date = valid && !!today && format(today, "dd-MM-yyyy");
//         setTime(currentTime);
//         setDisplayDate(date);
//         dispatch(updateDateTime({ currentDate, currentTime }));
//         timeStamp = new Date(res);
//       });
//   }, []);

//   React.useEffect(() => {
//     const interval = setInterval(() => {
//       fetchCurrentDateTime()
//         .then((response) => response.data)
//         .then((res) => {
//           const currentDate = new Date(res).valueOf();
//           localStorage.setItem("dateTime", Number(currentDate));
//           localStorage.setItem("dateTimeString", new Date(res));
//           let today = timeStamp;
//           let valid = isValid(today);
//           const currentTime = valid && !!today && format(today, "hh:mm a");
//           const date = valid && !!today && format(today, "dd-MM-yyyy");
//           setTime(currentTime);
//           setDisplayDate(date);
//           dispatch(updateDateTime({ currentDate, currentTime }));
//           timeStamp = new Date(res);
//         });
//     }, 60000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className=" text-center p-2 text-xs hidden lg:grid">
//       <span>{displayDate}</span>
//       <span>{time}</span>
//     </div>
//   );
// }
